import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "person-bubble"
}
const _hoisted_2 = { class: "person-bubble__circle" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "circle__action-fg" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "icon icon--open action__icon",
    viewBox: "0 0 200 200",
    "aria-hidden": "true"
  }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-open" })
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "circle__action-bg" }, null, -1)
const _hoisted_5 = ["src", "alt", "height", "width"]

import { ref } from 'vue';
import { customError, customLog } from '../../../../javascripts/utils/log';


export default {
  __name: 'person-bubble',
  props: {
  personId: {
    type: String,
    required: true,
    validator: (personId) => personId.length > 0,
  },
  personImage: {
    type: Object,
    required: true,
    validator: (personImage) => personImage.src && personImage.alt && personImage.height && personImage.width,
  }
},
  emits: {
  personBubbleClicked: (personId) => {
    if (personId) {
      customLog(`[PersonBubble]: personBubbleClicked event emitted with id ${personId}`);
      return true;
    } else {
      customError('[PersonBubble]: personBubbleClicked event must have an id');
      return false;
    }
  }
},
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

// Touch handling
let isMoving = ref(false);
let startX = ref(0);
let startY = ref(0);

function handleTouchStart(event) {
  startX.value = event.touches[0].clientX;
  startY.value = event.touches[0].clientY;
  isMoving.value = false;
}

function handleTouchMove() {
  isMoving.value = true;
}

function handleTouchEnd() {
  if (!isMoving.value) {
    handleClick();
  }
}

function handleClick() {
  customLog('[PersonBubble]: person bubble has been clicked');
  emit('personBubbleClicked', props.personId);
}

return (_ctx, _cache) => {
  return (__props.personId && __props.personImage)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "person-bubble__ring",
          onClick: handleClick,
          onTouchstart: handleTouchStart,
          onTouchmove: handleTouchMove,
          onTouchend: handleTouchEnd
        }, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("img", {
              class: "circle__picture",
              src: __props.personImage.src,
              alt: __props.personImage.alt,
              height: __props.personImage.height,
              width: __props.personImage.width
            }, null, 8, _hoisted_5)
          ])
        ], 32)
      ]))
    : _createCommentVNode("", true)
}
}

}